var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93604 16.92C13.319 16.92 16.8721 13.3562 16.8721 8.96001C16.8721 4.56382 13.319 1 8.93604 1C4.5531 1 1 4.56382 1 8.96001C1 13.3562 4.5531 16.92 8.93604 16.92Z",
    stroke: "#F1414D",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91211 4.69238L8.91211 9.48756",
    stroke: "#F1414D",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91195 12.6046C9.26359 12.6046 9.53532 12.3408 9.53532 12.0052C9.53532 11.6695 9.26359 11.4058 8.91195 11.4058C8.5603 11.4058 8.28857 11.6695 8.28857 12.0052C8.28857 12.3408 8.5603 12.6046 8.91195 12.6046Z",
    stroke: "#F1414D",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.7c818337806f2b715c3bb6353b1e7c81.svg";
export { ForwardRef as ReactComponent };